import { Action } from '@ngrx/store';
import { Brand, File } from '@app/models';
import { Update, UpdateSuccess } from './member.actions';
import { UpdateStr } from '@ngrx/entity/src/models';

export enum BrandActionTypes {
  Load = '[Brand] Load',
  LoadSuccess = '[Brand] Load Success',
  LoadFail = '[Brand] Load Fail',
  AddPicture = '[Brand] Add picture',

  Create = '[API] Create brand',
  CreateSuccess = '[API] Create brand success',
  CreateFail = '[API] Create brand fail',
  AddOne = '[Brand] Add one',

  UpdateBrand = '[API] Update brand',
  UpdateBrandSuccess = '[Brand] Update brand success',
  UpdateFail = '[Brand] Update brand fail',
  UpdateBrandOne = '[Brand] Update brand one'
}

export class Load implements Action {
  readonly type = BrandActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = BrandActionTypes.LoadSuccess;
  constructor(public brands: Brand[]) {}
}

export class LoadFail implements Action {
  readonly type = BrandActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddPicture implements Action {
  readonly type = BrandActionTypes.AddPicture;
  constructor(public file: File) {}
}

export class Create implements Action {
  readonly type = BrandActionTypes.Create;
  constructor(public brand: Brand) {}
}

export class CreateSuccess implements Action {
  readonly type = BrandActionTypes.CreateSuccess;
  constructor(public brand: Brand) {}
}

export class CreateFail implements Action {
  readonly type = BrandActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = BrandActionTypes.AddOne;
  constructor(public brand: Brand) {}
}

export class UpdateBrand implements Action {
  readonly type = BrandActionTypes.UpdateBrand;
  constructor(public id: number, public brand: any) {}
}

export class UpdateFail implements Action {
  readonly type = BrandActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateBrandSuccess implements Action {
  readonly type = BrandActionTypes.UpdateBrandSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateBrandOne implements Action {
  readonly type = BrandActionTypes.UpdateBrandOne;
  constructor(public brand: Brand) {}
}

export type BrandActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | AddPicture
  | Create
  | CreateSuccess
  | CreateFail
  | AddOne
  | UpdateBrand
  | UpdateBrandSuccess
  | UpdateFail
  | UpdateBrandOne;
